<template>
  <div class="">
    <PreLoader v-if="isLoading" />
    <ExceptionWithImg v-if="exceptionMsg" :msg="exceptionMsg" />

    <form
      autocomplete="off"
      method="post"
      @submit.prevent="addOrUpdateSpecialSpecialty()"
    >
      <div class="my-card">
        <div class="row">
          <div class="form-label-group col-12">
            <b-form-select
              v-model="specialSpecialtyData.generalSpecialtyToken"
              :options="generalSpecialtyTokenOptions"
              class="form-control"
            ></b-form-select>
            <img src="@/assets/images/special-spcialities.svg" />
          </div>
          <CustomInput
            :className="'col-md-6'"
            :id="'specialSpecialtyNameAr'"
            :value="specialSpecialtyData.specialSpecialtyNameAr"
            :title="$t('nameAr')"
            :imgName="'special-spcialities.svg'"
            v-on:changeValue="
              specialSpecialtyData.specialSpecialtyNameAr = $event
            "
          />
          <CustomInput
            :className="'col-md-6'"
            :id="'specialSpecialtyNameEn'"
            :value="specialSpecialtyData.specialSpecialtyNameEn"
            :title="$t('nameEn')"
            :imgName="'special-spcialities.svg'"
            v-on:changeValue="
              specialSpecialtyData.specialSpecialtyNameEn = $event
            "
          />
          <CustomInput
            :className="'col-md-6'"
            :id="'specialSpecialtyNameUnd'"
            :value="specialSpecialtyData.specialSpecialtyNameUnd"
            :title="$t('nameUnd')"
            :imgName="'special-spcialities.svg'"
            v-on:changeValue="
              specialSpecialtyData.specialSpecialtyNameUnd = $event
            "
          />

          <TextArea
            :className="'col-md-6'"
            :id="'specialSpecialtyDescriptionAr'"
            :value="specialSpecialtyData.specialSpecialtyDescriptionAr"
            :title="$t('specialSpecialtyDescriptionAr')"
            :imgName="'description.svg'"
            v-on:changeValue="
              specialSpecialtyData.specialSpecialtyDescriptionAr = $event
            "
          />
          <TextArea
            :className="'col-md-6'"
            :id="'specialSpecialtyDescriptionEn'"
            :value="specialSpecialtyData.specialSpecialtyDescriptionEn"
            :title="$t('specialSpecialtyDescriptionEn')"
            :imgName="'description.svg'"
            v-on:changeValue="
              specialSpecialtyData.specialSpecialtyDescriptionEn = $event
            "
          />
          <TextArea
            :className="'col-md-6'"
            :id="'specialSpecialtyDescriptionUnd'"
            :value="specialSpecialtyData.specialSpecialtyDescriptionUnd"
            :title="$t('specialSpecialtyDescriptionUnd')"
            :imgName="'description.svg'"
            v-on:changeValue="
              specialSpecialtyData.specialSpecialtyDescriptionUnd = $event
            "
          />

          <TextArea
            :className="'col-md-12'"
            :id="'specialSpecialtyNotes'"
            :value="specialSpecialtyData.specialSpecialtyNotes"
            :title="$t('notes')"
            :imgName="'notes.svg'"
            v-on:changeValue="
              specialSpecialtyData.specialSpecialtyNotes = $event
            "
          />
        </div>
      </div>

      <div class="form-footer">
        <button name="submit" type="submit" class="btn btn-submit">
          {{ submitName }}
        </button>
        <router-link to="/special-specialties" class="btn btn-cancel">
          {{ $t("cancel") }}
        </router-link>
      </div>
    </form>
  </div>
</template>

<script>
import PreLoader from "@/components/general/PreLoader.vue";
import ExceptionWithImg from "@/components/general/ExceptionWithImg.vue";
import CustomInput from "@/components/general/CustomInput.vue";
import TextArea from "@/components/general/TextArea.vue";
import { STATUS } from "@/utils/constants";
import axios from "axios";

export default {
  name: "SpecialSpecialtyForm",
  components: {
    PreLoader,
    ExceptionWithImg,
    CustomInput,
    TextArea,
  },
  data() {
    return {
      isLoading: false,
      exceptionMsg: null,
      exceptionImg: null,
      language: localStorage.getItem("userLanguage") || "ar",
      userAuthorizeToken:
        this.$store.getters.userData.userPersonalData.userAuthorizeToken ||
        null,
      generalSpecialtyTokenOptions: [],
    };
  },
  props: ["specialSpecialtyData", "submitName"],
  methods: {
    async addOrUpdateSpecialSpecialty() {
      this.$emit("addOrUpdateSpecialSpecialty");
    },
    async getDialogOfGeneralSpecialties() {
      this.isLoading = true;
      this.generalSpecialtyTokenOptions = [];
      this.generalSpecialtyTokenOptions.push({
        value: "",
        text: this.$t("selectGeneralSpecialty"),
      });
      try {
        const response = await axios.get(
          `/GeneralSpecialties/GetDialogOfGeneralSpecialties?language=${this.language}&userAuthorizeToken=${this.userAuthorizeToken}`
        );
        const itemsData = response.data.itemsData;
        if (response.data.status == STATUS.SUCCESS) {
          for (let item in itemsData) {
            this.generalSpecialtyTokenOptions.push({
              value: itemsData[item]["itemToken"],
              text:
                this.language == "en"
                  ? itemsData[item]["itemNameEn"]
                  : itemsData[item]["itemNameAr"],
            });
          }
        } else if (response.data.status == STATUS.INVALID_TOKEN) {
          this.$store.dispatch("logoutUser");
          this.$router.push("/").catch(() => {});
        }
        this.isLoading = false;
      } catch (error) {
        this.showMsg(this.$t("errorCatch"));
        this.generalSpecialtyTokenOptions = null;
      }
      this.isLoading = false;
    },
    setDataMultiLang(lang, dataAr, dataEn) {
      if (lang == "en") return dataEn;
      else return dataAr;
    },
  },
  watch: {},
  async created() {
    this.getDialogOfGeneralSpecialties();
  },
};
</script>

<style lang="scss"></style>
